import '../assets/css/im.css';

const Im = () => {

    return (
        <div className="short_intro_container">
            <h2>i'm<br className="break-line"></br>
                <span className="text_style" style={{ '--i': 10 }} data-text="Web Developer.">Web Developer.</span>
                <span className="text_style" style={{ '--i': 9 }} data-text="Backend Developer.">Backend Developer.</span>
                <span className="text_style" style={{ '--i': 8 }} data-text="Frontend Developer.">Frontend Developer.</span>
                <span className="text_style" style={{ '--i': 7 }} data-text="API Integrator.">API Integrator.</span>
                <span className="text_style" style={{ '--i': 6 }} data-text="Full Stack Engineer.">Full Stack Engineer.</span>
                <span className="text_style" style={{ '--i': 5 }} data-text="Coder.">Coder.</span>
                <span className="text_style" style={{ '--i': 4 }} data-text="Problem Solver.">Problem Solver.</span>
                <span className="text_style" style={{ '--i': 3 }} data-text="Fast Learner.">Fast Learner.</span>
                <span className="text_style" style={{ '--i': 2 }} data-text="Team Player.">Team Player.</span>
                <span className="text_style" style={{ '--i': 1 }} data-text="Creative Thinker.">Creative Thinker.</span>

            </h2>
        </div>
    );
}

export default Im;
